import React, { Component, useState, useEffect } from "react";
import moment from "moment";
import { getSubdomain, cleanLocalSetup } from "../helpers/Utils";
import _ from "lodash";

const AuthContext = React.createContext();

  const emptyUser = {
    firstName: "",
    lastName: "",
    emailAddress: "",
    profilePictureUrl: null
  }

const AuthProvider = ( props ) => {
  const [state, setState] = useState({
      token: localStorage.getItem("token"),
      account: localStorage.getItem("account_id"),
      user: localStorage.getItem("user") != null ? JSON.parse(localStorage.getItem("user")) : emptyUser,
    });

  //save user info in local storage
  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(state.user));
  }, [state.user]);

  const authFetch = async (input: RequestInfo, init?: RequestInit): Promise<Response> => {
      init = init || {};
      init.headers = {
          ...init.headers,
          "X-BH-IPASS-AUTH-TOKEN": state.token,
        };
      if (init.body){
        init.headers = {
          ...init.headers,
          "Content-Type": "application/json",
        }
      }
      return fetch(input, init).then((response) => {
        if (response.ok) {
          return response;
        } else {
          if (response.status == 401){
            logout();
          }
          let error = new Error('Something went wrong');
          throw {...error, response};
        }
      });
  };

  const residentAuthFetch = async (input: RequestInfo, init?: RequestInit): Promise<Response> => {
    init = init || {};
    init.headers = {
        ...init.headers,
        "X-BH-IPASS-RESIDENT-AUTH-TOKEN": state.token,
      };
    if (init.body){
      init.headers = {
        ...init.headers,
        "Content-Type": "application/json",
      }
    }
    return fetch(input, init).then((response) => {
        if (response.ok) {
          return response;
        } else {
          if (response.status == 401){
            logout();
          }
          let error = new Error('Something went wrong');
          throw {...error, response};
        }
      });
  };

  const login = async ( data ) => {
    console.log("data", data)
    var user = {};
    if (data.user.dateOfBirth){
      var user = {...data.user, dateOfBirth:moment(data.user.dateOfBirth).format("yyyy-MM-DD")};
    }else{
      user = {...data.user}
    }
    
    if (data.user.addresses && data.user.addresses.length>0){
      user = {...user, address: {...data.user.addresses[0]}}
    }

    let aId = undefined;
    if(_.has(data.user, 'accounts')) {
      let accountFiltered =  getAccountId(data.user.accounts);
      
      if(accountFiltered.length == 0) {
        accountFiltered = data.user.accounts;
      }

      aId = accountFiltered[0].id;
    } else {
      aId = data.user.account.id;
    }

    setState({
      token:data.token,
      account:aId, 
      user:user 
    });
    
    localStorage.setItem("account_id", aId); //for requests
    localStorage.setItem("token", data.token); //for auth
    console.log("User logged in");
  };

  /**
   * 
   */
  const getAccountId = (accounts) => {
    const subdomain = getSubdomain();
    return accounts.filter(a => a.subdomain == subdomain);
  }

  const setUserProfile = (profile) => {
    setState({
      ...state,
      user:{
        ...state.user,
        ...profile
      }
    });
  }

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("account_id"); 
    localStorage.removeItem("user");
    localStorage.removeItem("selected_property");
    localStorage.removeItem("login_referrer");
    cleanLocalSetup();
    console.log("User logged out");
  };

  const register = ( data ) => {
    setState({ ...state, ...data});
  };

  return (
    <AuthContext.Provider
      value={{...state, login, logout, authFetch, residentAuthFetch, setUserProfile}} {...props}>
    </AuthContext.Provider>
  );
}

export { AuthProvider, AuthContext };